import React, { useState, useEffect } from "react";
import Edit from "./svg/Edit";
import Toggle from "./svg/Toggle";
import PropTypes from "prop-types";
import MainServices from "../../../../services/MainServices";
import { toast } from "react-toastify";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";
import DependentsFormWrapper from "./DependentsFromWrapper";

const Dependents = ({
  personalInfo,
  dependentsInfo: initialDetails,
  handleGetTableData,
  empPublicId,
  getEmployeeRegistrationData,
}) => {
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [dependentsList, setDependentsList] = useState([]);
  const [expandedDependent, setExpandedDependent] = useState(null);
  const [currentDependentData, setCurrentDependentData] = useState({});
  const [newDependentData, setNewDependentData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const {
    updateDependentsInfo,
    updateEmployeeRegistrationMaster,
    addDependentInfo, // Assuming this service exists
    getNationalityMaster,
    getRelationMaster,
    getReligionMaster,
    getCountryMaster,
  } = MainServices();

  useEffect(() => {
    if (initialDetails) {
      setLoading(false);
    }
  }, [initialDetails]);

  const [countryOptions, setCountryOptions] = useState([]);
  const [relationOptions, setRelationOptions] = useState([]);
  const [religionOptions, setReligionOptions] = useState([]);

  console.log("dependents list: ", dependentsList);
  console.log("dependentsinfo : ", initialDetails);

  useEffect(() => {
    getNationalityOptions();
    getRelationOptions();
    getReligionOptions();
  }, []);

  const getRelationOptions = async () => {
    try {
      const dummyRelations = [
        { label: "Father", value: "Father" },
        { label: "Mother", value: "Mother" },
        { label: "Brother", value: "Brother" },
        { label: "Sister", value: "Sister" },
        { label: "Son", value: "Son" },
        { label: "Daughter", value: "Daughter" },
        { label: "Husband", value: "Husband" },
        { label: "Wife", value: "Wife" },
        { label: "Uncle", value: "Uncle" },
        { label: "Aunt", value: "Aunt" },
        { label: "Nephew", value: "Nephew" },
        { label: "Niece", value: "Niece" },
        { label: "Cousin", value: "Cousin" },
        { label: "Grandfather", value: "Grandfather" },
        { label: "Grandmother", value: "Grandmother" },
        { label: "Grandson", value: "Grandson" },
        { label: "Granddaughter", value: "Granddaughter" },
      ];

      setRelationOptions(dummyRelations);
    } catch (error) {
      console.error(error);
    }
  };

  const onSearchRelation = async (inputValue, callback) => {
    if (!inputValue) {
      callback(relationOptions);
      return;
    }

    // Filter the existing static relationOptions based on inputValue
    const filteredOptions = relationOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );

    callback(filteredOptions);
  };

  const onSearchRelationDebounce = (inputValue, callback) => {
    deBounce(() => onSearchRelation(inputValue, callback), 1000)();
  };

  const getNationalityOptions = async (filters, search) => {
    const details = {
      pageSize: "20",
      filters,
    };

    try {
      const response = await getCountryMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((country) => ({
          label: country.name,
          value: country.publicId,
        }));

        !search && setCountryOptions(options);
        return options;
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchCountry = async (inputValue, callback) => {
    if (!inputValue) {
      callback(countryOptions);
      return;
    }

    const filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    const options = await getNationalityOptions(filter, true);
    callback(options);
  };

  const onSearchCountryDebounce = (inputValue, callback) => {
    deBounce(() => onSearchCountry(inputValue, callback), 1000)();
  };

  // Religion options loading
  const getReligionOptions = async (filters, search) => {
    const details = {
      pageSize: "20",
      filters,
    };

    try {
      const response = await getReligionMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((religion) => ({
          label: religion.name,
          value: religion.publicId,
        }));

        !search && setReligionOptions(options);
        return options;
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchReligion = async (inputValue, callback) => {
    if (!inputValue) {
      callback(religionOptions);
      return;
    }

    const filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    const options = await getReligionOptions(filter, true);
    callback(options);
  };

  const onSearchReligionDebounce = (inputValue, callback) => {
    deBounce(() => onSearchReligion(inputValue, callback), 1000)();
  };

  if (loading) return <p className="text-center text-gray-500">Loading...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  const handleSubmit = async (dependentsInfo) => {
    try {
      const formattedPersonalInfo = {
        ...(personalInfo?.firstName && { firstName: personalInfo.firstName }),
        ...(personalInfo?.secondName && {
          secondName: personalInfo.secondName,
        }),
        ...(personalInfo?.thirdName && { thirdName: personalInfo.thirdName }),
        ...(personalInfo?.lastName && { lastName: personalInfo.lastName }),
        ...(personalInfo?.phone && { phone: personalInfo.phone }),
        ...(personalInfo?.email && { email: personalInfo.email }),
        ...(personalInfo?.dobHijri && { dobHijri: personalInfo.dobHijri }),
        ...(personalInfo?.dobGregorian && {
          dobGregorian: personalInfo.dobGregorian,
        }),
        ...(personalInfo?.religion && { religion: personalInfo.religion }),
        ...(personalInfo?.maritalStatus && {
          maritalStatus: personalInfo.maritalStatus,
        }),
        ...(personalInfo?.gender && { gender: personalInfo.gender }),
        ...(personalInfo?.citizen && { citizen: personalInfo.citizen }),
        ...(personalInfo?.citizen === "false" &&
          personalInfo?.nationality && {
            nationality: personalInfo?.nationality,
          }),
        ...(personalInfo?.citizen === "true" &&
          personalInfo?.nationalId && {
            nationalId: personalInfo.nationalId,
          }),
      };

      const payload = {
        ...formattedPersonalInfo,
        dependentsInfo: dependentsInfo,
      };

      const response = await updateEmployeeRegistrationMaster(
        payload,
        empPublicId,
        personalInfo?.concurrencyStamp
      );

      if (response?.data) {
        toast.success("Dependents information updated successfully");
        getEmployeeRegistrationData(empPublicId);
        handleGetTableData();
      }
    } catch (error) {
      console.error("Error updating dependents:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to update dependents information"
      );
    }
  };

  const deBounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  return (
    <>
      <DependentsFormWrapper
        initialDependents={initialDetails}
        countryOptions={countryOptions}
        religionOptions={religionOptions}
        relationOptions={relationOptions}
        loadCountryOptions={onSearchCountryDebounce}
        loadReligionOptions={onSearchReligionDebounce}
        loadRelationOptions={onSearchRelationDebounce}
        onSubmit={handleSubmit}
        t={t}
      />
    </>
  );
};

Dependents.propTypes = {
  dependentsInfo: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  handleGetTableData: PropTypes.func,
  empPublicId: PropTypes.string,
  getEmployeeRegistrationData: PropTypes.func,
};

export default Dependents;
